import { FC } from 'react';
import GoalVisitPage from '../../primitive/Icons/GoalVisitPage';
import GoalClick from '../../primitive/Icons/GoalClick';
import GoalEvent from '../../primitive/Icons/GoalEvent';
import GoalTransaction from '../../primitive/Icons/GoalTransaction';
import { TriggerType } from '../../../../entity/types';

type Props = {
  type: TriggerType;
  size?: number;
  color?: string;
};

const GoalTypeIcon: FC<Props> = ({ type, size, color }) => {
  switch (type) {
    case 'PAGE_VISIT':
      return <GoalVisitPage size={size} color={color} />;
    case 'CLICK':
      return <GoalClick size={size} color={color} />;
    case 'EVENT':
      return <GoalEvent size={size} color={color} />;
    case 'TRANSACTION':
      return <GoalTransaction size={size} color={color} />;
    default:
      return null;
  }
};

export default GoalTypeIcon;
